import { PHASER_1, PHASER_2, PHOTON, PHASER_3, DISRUPTOR } from '../model/weapon'
import { Ship, ShipClass } from '../model/ship'
import { Point } from '../math/point'
import { Angle } from '../math/angle'
import { Sprite } from '../model/sprite'

const phaser1forward = PHASER_1.create("ph1forward", [0,1,3], 0, 2)
const phaser1aft = PHASER_1.create("ph1aft", [1,2,3], Angle.PI_2, 2)
const phaser1a = PHASER_1.create("ph1a", [0,1], Angle.PI_4, 2)
const phaser1b = PHASER_1.create("ph1b", [0,3], Angle.TWO_PI - Angle.PI_4, 2)
const phaser1c = PHASER_1.create("ph1c", [0], 0, 2)

const phaser1ka = PHASER_1.create("ph1ka", [0,3], Angle.TWO_PI - Angle.PI_4, 2)
const phaser1kb = PHASER_1.create("ph1ka", [0,1],  Angle.PI_4, 2)
const phaser2a = PHASER_2.create("ph2a", [1,2,3], Angle.TWO_PI, 2)
const phaser3a = PHASER_3.create("ph3a", [0,1,2,3], 0, 2)

const distuptor1 = DISRUPTOR.create("disr1", [0], 0, 5)

const photon1a = PHOTON.create("phot1a", [0], 0, 5)

const HEAVY_CRUISER = new ShipClass(
  "Heavy Cruiser", 25, 18,
  32, [12, 12, 12, 12],
  // 1, [1, 1, 1, 1],
  // [photon1a]
  [phaser1forward, phaser1a, phaser1b, phaser1aft, phaser3a, photon1a]
)

const LIGHT_FRIGATE = new ShipClass(
  "Light Frigate", 25, 18,
  15, [5, 5, 5, 5],
  // 1, [1, 1, 1, 1],
  // 2, [2, 2, 2, 2],
  [phaser1ka, phaser1kb, phaser2a, distuptor1]
)

const FRIGATE = new ShipClass(
  "Frigate", 15, 18,
  18, [8, 8, 8, 8],
  [phaser1ka, phaser1kb, phaser2a, distuptor1]
)

// const spriteScale = 1.2083 // x 24 = 28.999

export class ShipBuilder {
  player(): Ship {
    const sprite = new Sprite('player')
    const player = HEAVY_CRUISER.create("Flagship", new Point(0, -80), Angle.PI_2, sprite)

    return player
  }

  enemies(): Ship[] {
    const sprite0 = new Sprite('enemy1')
    const enemy0 = FRIGATE.create("Krellen 0", new Point(0, 90), Angle.PI + Angle.PI_2, sprite0)//0, sprite1)


    const sprite1 = new Sprite('enemy2')
    const enemy1 = LIGHT_FRIGATE.create("Krellen 1", new Point(30, 80), Angle.PI + Angle.PI_2, sprite1)//0, sprite1)

    const sprite2 = new Sprite('enemy2')
    const enemy2 = LIGHT_FRIGATE.create("Krellen 2", new Point(-30, 80), Angle.PI + Angle.PI_2, sprite2)

    return [enemy0, enemy1, enemy2]
  }
}